import { useEffect } from 'react';
import { useViewSubmissionsQuery } from '../services/api';
import { errorToast } from '../utils/toasts';

/**
 * Fetch submissions (acceptable params are id)
 * The parameters are optional
 */
export const useFetchSubmissions = ({ id } = {}) => {
  const { data, error, isError, isFetching, isLoading } = useViewSubmissionsQuery({
    id,
  });

  useEffect(() => {
    if (isError) {
      errorToast('Unable to fetch submissions. Please try again later.');
      console.error(error);
    }
  }, [error, isError]);

  return {
    data,
    isError,
    isFetching,
    isLoading,
    submissions: data && data.submissions ? data.submissions : [],
  };
};
